var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3853 15.2737C17.9021 14.558 17.5979 13.7526 17.5979 12.8937V11.1937C17.5979 8.38418 15.8621 6.27266 13.1779 5.71793V5.03789C13.1779 4.4652 12.7127 4 12.14 4H11.5495C10.9768 4 10.5116 4.46523 10.5116 5.03789V5.71793C7.84525 6.29062 6.0916 8.40214 6.0916 11.1937V12.8937C6.0916 13.7526 5.7874 14.5758 5.30419 15.2737C5.10735 15.56 5 15.9001 5 16.2579V16.4011C5 17.3674 5.7874 18.1548 6.75365 18.1548H16.9358C17.902 18.1548 18.6894 17.3674 18.6894 16.4011V16.2579C18.6897 15.8999 18.5822 15.56 18.3853 15.2737Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9999 22C13.6571 22 14.9713 20.6572 15 19H9C9.0287 20.6571 10.3429 22 12.0001 22H11.9999Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications1);
export default __webpack_public_path__ + "static/media/notifications1.91b008a191cfa11ee485aa30771d71c7.svg";
export { ForwardRef as ReactComponent };